/**
 * @file List Order Options
 * @author tobias.frei@notch-interactive.com
 *
 * @module components/list-order-options
 *
 * Custom Event:
 * document.querySelector('.list-options').addEventListener('sortchange', function (e) {
 *  console.log(e.detail.name);
 *  console.log(e.detail.dir);
 * }, false);
 *
 */

const instance = {},

    /**
     *
     * @typedef defaults
     */

    defaults = {
        listOrderOptions: '[data-list-options]',
        mediaQuery: '(max-width: 40em), (min-width: 48em) and (max-width: 63.999em)',
        classes: {
            selected: 'is-selected',
            isopen: 'is-open',
            item: 'list-options__item'
        },
        hooks: {
            listOrderItem: '[data-name]',
            mobileTrigger: '[data-list-mobtrigger]',
            wrapper: '[data-list-wrap]'
        }
    };

let settings,
    listOrderComponents,
    mq,
    modulMode;

const bindEvents = () => {
        // set mediaQuery Object
        mq = window.matchMedia(settings.mediaQuery);

        // set listener for tabs/accordion modes
        mq.addListener(switchMode);

        // set inital mode
        switchMode(mq);

        listOrderComponents.forEach((listOrderComponent) => {
            [...listOrderComponent.querySelectorAll(settings.hooks.listOrderItem)].forEach((listOrderItem) => {
                listOrderItem.mainModule = listOrderComponent;
                listOrderItem.addEventListener('click', toggleSort);
            });
        });
    },
    unbindEvents = () => {
        listOrderComponents.forEach((listOrderComponent) => {
            [...listOrderComponent.querySelectorAll(settings.hooks.listOrderItem)].forEach((listOrderItem) => {
                listOrderItem.removeEventListener('click', toggleSort);
            });
        });
    },
    bindMobileEvents = () => {
        listOrderComponents.forEach((listOrderComponent) => {
            [...listOrderComponent.querySelectorAll(settings.hooks.mobileTrigger)].forEach((mobTrigger) => {
                mobTrigger.mainModule = listOrderComponent;
                mobTrigger.addEventListener('click', mobileTrigger);
            });
        });
    },
    unbindMobileEvents = () => {
        listOrderComponents.forEach((listOrderComponent) => {
            [...listOrderComponent.querySelectorAll(settings.hooks.mobileTrigger)].forEach((mobTrigger) => {
                mobTrigger.removeEventListener('click', mobileTrigger);
            });
        });
    },
    switchMode = (mq) => {
        if (!mq.matches) {
            // desktop style
            modulMode = 1;
            cleanStyles();
            unbindMobileEvents();
        } else {
            // mobile style
            modulMode = 2;
            cleanStyles();
            bindMobileEvents();
        }
    },
    cleanStyles = () => {
        listOrderComponents.forEach((listOrderComponent) => {
            listOrderComponent.setAttribute('style', '');
        });
    },
    toggleSort = (e) => {
        let item = e.target;
        if (!item.classList.contains(settings.classes.item)) {
            item = item.closest(settings.hooks.listOrderItem);
        }
        if (item.classList.contains(settings.classes.selected)) {
            switchDir(item);
        } else {
            setItem(item);
        }
        if(modulMode===2) {
            mobileClose(item.mainModule.querySelector(settings.hooks.mobileTrigger));
        }
    },
    switchDir = (item) => {
        let actDir = item.getAttribute('data-dir');
        switch (actDir) {
            case 'asc':
                actDir = 'desc';
                break;
            case 'desc':
                actDir = 'asc';
                break;
        }
        item.setAttribute('data-dir', actDir);
        dispEvent(item);
    },
    setItem = (item) => {
        [...item.mainModule.querySelectorAll('.' + settings.classes.selected + settings.hooks.listOrderItem)].forEach((selItem) => {
            selItem.classList.remove(settings.classes.selected);
        });
        item.classList.add(settings.classes.selected);
        dispEvent(item);
    },
    dispMobile = (item, data) => {
        let mobileItem = item.mainModule.querySelector('.list-options__item--mob .list-options_lbl');
        mobileItem.setAttribute('data-sel-name', data.detail.label);
        mobileItem.setAttribute('data-sel-dir', data.detail.dir);
    },
    dispEvent = (item) => {
        let data = {
                'detail': {
                    'name': item.getAttribute('data-name'),
                    'dir': item.getAttribute('data-dir'),
                    'label': item.getAttribute('data-label')
                }
            },
            custEvent = new CustomEvent('sortchange', data);
        item.mainModule.dispatchEvent(custEvent);
        dispMobile(item, data);
    },
    mobileTrigger = (e) => {
        let item = e.target;
        if (!item.classList.contains(settings.classes.item)) {
            item = item.closest(settings.hooks.mobileTrigger);
        }
        if (item.classList.contains(settings.classes.isopen)) {
            mobileClose(item);
        } else {
            mobileOpen(item);
        }
    },
    mobileClose = (item) => {
        item.mainModule.style.height = '60px';
        item.classList.remove(settings.classes.isopen);
    },
    mobileOpen = (item) => {
        item.mainModule.style.height = item.mainModule.querySelector(settings.hooks.wrapper).offsetHeight + 'px';
        item.classList.add(settings.classes.isopen);
    };

/**
 * Initialize module
 *
 * @param {object} options - Override default settings with options object.
 * @return {object} Instance of created module.
 */

instance.init = (options) => {
    settings = Object.assign({}, defaults, options);

    listOrderComponents = [...document.querySelectorAll(settings.listOrderOptions)];

    bindEvents();

    return instance;
};


/**
 * Destroy this module.
 */

instance.destroy = () => {
    unbindEvents();
};


export default instance;
